import { basicPath } from '../basicPath';

export const fetchTextLogs = (params) => async (dispatch) => {
    const path = '/mp/text-logs/daterange';
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}